(function cookieBanner() {
  var STORAGE_KEY = 'cookie_banner_dismissed';
  var EXPIRY_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

  var banner = document.getElementById('cookie-banner');
  if (!banner) return;

  // Check localStorage — if dismissed less than 7 days ago, stay hidden
  var stored = localStorage.getItem(STORAGE_KEY);
  if (stored) {
    var dismissedAt = parseInt(stored, 10);
    if (!isNaN(dismissedAt) && Date.now() - dismissedAt < EXPIRY_MS) {
      banner.style.display = 'none';
      return;
    }
  }

  // Show banner with fade-in
  function showBanner() {
    banner.style.display = '';
    // Force reflow so the transition fires
    banner.getBoundingClientRect();
    banner.classList.add('cookie-banner--visible');
  }

  // Dismiss with fade-out then hide
  function dismissBanner() {
    banner.classList.remove('cookie-banner--visible');
    banner.addEventListener('transitionend', function () {
      banner.style.display = 'none';
    }, { once: true });
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  }

  // Wire up dismiss button
  var btn = document.getElementById('cookie-banner-btn');
  if (btn) {
    btn.addEventListener('click', dismissBanner);
  }

  // Auto-dismiss
  var autoDismiss = banner.dataset.autoDismiss === 'true';
  var autoDismissSeconds = parseInt(banner.dataset.autoDismissSeconds, 10);
  if (autoDismiss && autoDismissSeconds > 0) {
    setTimeout(dismissBanner, autoDismissSeconds * 1000);
  }

  // Show on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showBanner);
  } else {
    showBanner();
  }
})();
